import { gql } from 'glimmer-apollo';

// Optimized query for reviews list page - excludes body content and optimizes images
export const REVIEWS_INDEX_OPTIMIZED_QUERY = gql`
  fragment AuthorInfo on Author {
    displayName
    profilePicture {
      url(
        transform: {
          width: 48
          height: 48
          resizeStrategy: THUMB
          format: WEBP
        }
      )
    }
  }

  fragment CoverImageInfo on Asset {
    url(
      transform: { width: 300, height: 180, resizeStrategy: FILL, format: WEBP }
    )
  }

  query ReviewsIndex($limit: Int = 10, $skip: Int = 0) {
    articles: reviewArticleCollection(
      limit: $limit
      skip: $skip
      order: [publishedDate_DESC]
    ) {
      total
      items {
        title
        slug
        shortDescription
        publishedDate
        coverImage {
          ...CoverImageInfo
        }
        author {
          ...AuthorInfo
        }
      }
    }
  }
`;

// For pagination and infinite scroll
export const REVIEWS_INDEX_PAGINATED_QUERY = gql`
  fragment AuthorInfo on Author {
    displayName
    profilePicture {
      url(
        transform: {
          width: 48
          height: 48
          resizeStrategy: THUMB
          format: WEBP
        }
      )
    }
  }

  fragment CoverImageInfo on Asset {
    url(
      transform: { width: 300, height: 180, resizeStrategy: FILL, format: WEBP }
    )
  }

  query ReviewsIndexPaginated($limit: Int!, $skip: Int!) {
    articles: reviewArticleCollection(
      limit: $limit
      skip: $skip
      order: [publishedDate_DESC]
    ) {
      total
      items {
        title
        slug
        shortDescription
        publishedDate
        coverImage {
          ...CoverImageInfo
        }
        author {
          ...AuthorInfo
        }
      }
    }
  }
`;
